import { Base } from '@studiometa/js-toolkit';
import { toggleClass, animate, easeOutQuart } from '@studiometa/js-toolkit/utils';

/**
 *  component
 */
export default class Header extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Header',
    refs: ['toggle', 'links[]', 'images[]'],
  };

  open = false;

  /**
   * On toggle click
   */
  onToggleClick() {
    this.open = !this.open;

    toggleClass(this.$el, 'header--opened', this.open);

    if (this.open) {
      document.body.style.overflow = 'hidden';

      this.$refs.links.forEach((link) => {
        const animation = animate(link, [{ y: link.clientHeight }, { y: 0 }], {
          duration: 1.2,
          easing: easeOutQuart,
        });

        animation.start();
      });
    } else {
      document.body.style.overflow = '';
    }
  }

  /**
   * onLinksMouseover
   * @param {*} link
   * @param {*} index
   */
  onLinksMouseover(link, index) {
    this.$refs.links.forEach((refLink, refLinkIndex) => {
      toggleClass(refLink, 'opacity-30', refLinkIndex !== index);
    });

    toggleClass(this.$refs.images[index], 'opacity-100 translate-y-0', true);
  }

  /**
   * onLinksMouseover
   */
  onLinksMouseleave() {
    this.$refs.links.forEach((refLink, refLinkIndex) => {
      toggleClass(refLink, 'opacity-30', false);
      toggleClass(this.$refs.images[refLinkIndex], 'opacity-100 translate-y-0', false);
    });
  }
}
